module.exports = __webpack_public_path__ + "static/media/Satv_what.a7ac6366.mp3";